/* bundle.js — Pique Vitality bundle builder. Client-side PREVIEW only; the real
   discount is a Shopify automatic discount applied at checkout. */
(function () {
  'use strict';

  const root = document.querySelector('[data-bundle]');
  if (!root) return;

  const target = parseInt(root.dataset.target, 10) || 5;
  const discount = parseFloat(root.dataset.discount) || 0;
  const savingMode = root.dataset.savingMode || 'amount';
  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

  const tiles = [...root.querySelectorAll('[data-bundle-item]')];
  const msgEl = root.querySelector('[data-bundle-msg]');
  const tallyEl = root.querySelector('[data-bundle-tally]');
  const trackFill = root.querySelector('[data-bundle-track] > i');
  const progressEl = root.querySelector('.bundle__progress');
  const linesEl = root.querySelector('[data-bundle-lines]');
  const subtotalEl = root.querySelector('[data-bundle-subtotal]');
  const saveEl = root.querySelector('[data-bundle-save]');
  const saveRow = root.querySelector('.bundle__totals-row--save');
  const totalEl = root.querySelector('[data-bundle-total]');
  const badgeEl = root.querySelector('[data-bundle-badge]');
  const submitBtns = [...document.querySelectorAll('[data-bundle-submit]')];
  const bar = document.querySelector('[data-bundle-bar]');
  const totalMobile = document.querySelector('[data-bundle-total-mobile]');
  const metaEl = document.querySelector('[data-bundle-meta]');

  const B = ((window.theme && window.theme.strings && window.theme.strings.bundle) || {});
  const t = (window.theme && window.theme.t) || function (s, v) { return s == null ? '' : (!v ? s : s.replace(/\[\[(\w+)\]\]/g, function (m, k) { return k in v ? v[k] : m; })); };

  const state = new Map(); // tile -> qty

  /* ---- Shopify-style money formatter (value in cents) ---- */
  function formatMoney(cents) {
    const value = (cents / 100);
    function withCommas(num, decimals) {
      const parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return decimals ? parts.join('.') : parts[0];
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, key) => {
      switch (key) {
        case 'amount': return withCommas(value, 2);
        case 'amount_no_decimals': return withCommas(value, 0);
        case 'amount_with_comma_separator': return withCommas(value, 2).replace(/,/g, '§').replace(/\./, ',').replace(/§/g, '.');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0).replace(/,/g, '.');
        default: return withCommas(value, 2);
      }
    });
  }

  function recompute() {
    let totalQty = 0;
    let subtotal = 0;
    const lines = [];
    tiles.forEach((tile) => {
      const qty = state.get(tile) || 0;
      const price = parseInt(tile.dataset.price, 10) || 0;
      totalQty += qty;
      subtotal += qty * price;
      tile.classList.toggle('is-active', qty > 0);
      if (qty > 0) lines.push({ title: tile.dataset.title, qty: qty, total: qty * price });
    });

    const met = totalQty >= target;
    const save = met ? Math.round(subtotal * discount / 100) : 0;
    const totalPrice = subtotal - save;
    const remaining = Math.max(0, target - totalQty);
    const pct = Math.min(100, target ? (totalQty / target) * 100 : 0);

    if (trackFill) trackFill.style.width = pct + '%';
    root.querySelector('[data-bundle-track]')?.classList.toggle('track--met', met);
    if (progressEl) progressEl.classList.toggle('is-met', met);
    if (tallyEl) tallyEl.textContent = t(B.tally, { current: totalQty, target: target });
    if (msgEl) {
      const savingText = savingMode === 'percent'
        ? t(B.percent_off, { discount: discount })
        : t(B.you_save, { amount: formatMoney(save) });
      const metSaving = savingMode === 'percent' ? t(B.percent_unlocked, { discount: discount }) : savingText;
      msgEl.textContent = met
        ? t(B.progress_met, { current: totalQty, target: target, saving: metSaving })
        : t(B.progress_add, { remaining: remaining, discount: discount });
    }

    if (linesEl) {
      linesEl.innerHTML = lines.length
        ? lines.map((l) => '<div class="bundle__line"><span>' + escapeHtml(l.title) + ' × ' + l.qty + '</span><span class="tnum">' + formatMoney(l.total) + '</span></div>').join('')
        : '<span class="bundle__lines-empty">' + (B.empty || 'No flavours added yet.') + '</span>';
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
    if (saveEl) saveEl.textContent = '–' + formatMoney(save);
    if (saveRow) saveRow.classList.toggle('is-on', met && save > 0);
    if (totalEl) totalEl.textContent = formatMoney(totalPrice);
    if (totalMobile) totalMobile.textContent = formatMoney(totalPrice);
    if (badgeEl) {
      badgeEl.textContent = t(B.badge, { current: totalQty, target: target }) + (met ? ' ✓' : '');
      badgeEl.className = 'badge ' + (met ? 'badge--best' : 'badge--sub');
    }
    if (metaEl) metaEl.textContent = met
      ? t(B.save_meta, { amount: formatMoney(save), current: totalQty, target: target })
      : t(B.added_meta, { current: totalQty, target: target });

    submitBtns.forEach((btn) => {
      btn.disabled = !met;
      btn.textContent = met ? (B.add_box || 'Add box to cart') : t(B.add_more, { remaining: remaining });
    });
  }

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  tiles.forEach((tile) => {
    tile.querySelector('[data-bundle-add]')?.addEventListener('click', () => {
      const rawMax = parseInt(tile.dataset.max, 10);
      const cap = isNaN(rawMax) ? Infinity : rawMax;
      const next = Math.min(cap, (state.get(tile) || 0) + 1);
      state.set(tile, next);
      tile.querySelector('[data-bundle-qty]').textContent = next;
      recompute();
    });
    tile.querySelector('[data-bundle-sub]')?.addEventListener('click', () => {
      state.set(tile, Math.max(0, (state.get(tile) || 0) - 1));
      tile.querySelector('[data-bundle-qty]').textContent = state.get(tile);
      recompute();
    });
  });

  async function addBox(btn) {
    const items = tiles
      .filter((t) => (state.get(t) || 0) > 0)
      .map((t) => ({ id: parseInt(t.dataset.id, 10), quantity: state.get(t) }));
    if (!items.length) return;
    const label = btn.textContent;
    const G = (window.theme && window.theme.strings) || {};
    btn.disabled = true; btn.textContent = G.adding || 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) {
        let detail = '';
        try { const data = await res.json(); detail = data.description || data.message || ''; } catch (e) {}
        throw new Error(detail || 'add failed');
      }
      window.location.href = '/cart';
    } catch (e) {
      btn.disabled = false; btn.textContent = G.try_again || 'Try again';
      if (msgEl && e.message && e.message !== 'add failed') msgEl.textContent = e.message;
      setTimeout(() => { btn.textContent = label; recompute(); }, 2200);
    }
  }
  submitBtns.forEach((btn) => btn.addEventListener('click', () => addBox(btn)));

  if (bar) bar.hidden = false;
  recompute();
})();
